export default "__VITE_ASSET__BQHciUQh__"